import React, { Component } from "react";

import Loader from "react-loader";
import { toast, ToastContainer } from "react-toastify";

import withServices from "src/HOCs/withServices";
import Navbar from "../../../components/CustomNav/CustomNav.Component";
import SwarmPlot from "../../../components/DataViz/SwarmPlot/SwarmPlot";
import { FabButton } from "../../Onboard/Common/Common.styles";

import { connect } from "react-redux";

import {
  getPerceptions,
  getCohorts,
  updateMultipleVals,
  getCohortsPerceptionData,
} from "../../../redux/ducks/teacherPerceptions";

import {
  Container,
  Heading,
  Wrapper,
  Row,
  ComponentWrapper,
  Button,
  Description,
} from "../School/ViewPerceptions/SchoolPerceptions.styles";

import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";

import { calcColor } from "src/common/services";
import { StyledStep } from "../../../components/ReactTourSteps/ReactTourSteps.styles";


export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Perceptions</h1>
        <p className="step-text">
          I can identify which Perception areas your learners may need support
          in. There are <span>eight</span> Perception areas, click a circle
          and I'll show you an overview of learners in the selected Perception
          area.
        </p>
        {/* <p className="step-link">
          Find out more about <span>step 1</span> in the
          <span>Help Center</span>{" "}
        </p> */}
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
];

interface IProps {
  services?: any;
  history?: any;
  dispatch?: any;
  perceptionsReducer?: any;
}
interface IState {
  guidesRead: boolean;
}

class SchoolPerceptions extends Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      guidesRead: true,
    };
  }

  public async componentDidMount() {
    const {
      services: { isUserLoggedIn },
    } = this.props;
    if (!isUserLoggedIn) {
      this.onLogout();
    }

    this.onSelectUserType();
  }

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}PerceptionsTour`,
      "true"
    );
    this.setState({ guidesRead: true });
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };

  public onLogout = () => {
    this.props.history.replace("/login");
  };
  public currentUserKey = () => {
    const { currentUserType } = this.props.perceptionsReducer;
    if (currentUserType === "students") {
      return "name_students";
    } else {
      return "name_teachers";
    }
  };
  public assignClass = (clicked, current) => {
    if (clicked === +current) {
      return "perception-active active";
    } else {
      return "";
    }
  };

  public toggleGuides = () => {
    const { guidesRead } = this.state;
    if (!this.props.perceptionsReducer.cohortID) {
      toast.info("First pick users and a cohort above");
      return;
    }
    this.setState({ guidesRead: !guidesRead });
  };

  public perceptionClickHandler = (event) => {
    const selected = event.target.value;
    this.props.dispatch(
      updateMultipleVals({ perceptionsDataLoaded: false, isLoading: true })
    );

    const {
      perceptionsReducer: { cohortID, cohorts, currentUserType },
      dispatch,
    } = this.props;

    if (cohortID === null || cohortID === "") {
      toast.warn("Pick a cohort first!");
    } else {
      const currentCohort = cohorts.find((c) => c.cohort === cohortID);

      dispatch(
        updateMultipleVals({
          selectedPerception: selected,
          perceptionsDataLoaded: false,
          studentCount: currentCohort.total,
          firstClickDone: true,
        })
      );

      dispatch(
        getCohortsPerceptionData(
          cohortID,
          selected
        )
      );
    }
  };

  public onSelectUserType = () => {
    this.props.dispatch(
      updateMultipleVals({
        cohortsLoaded: false,
        perceptionsDataLoaded: false,
        selectedPerception: null,
        cohortID: null,
        // currentUserType: e.target.targetVal,
      })
    );
    const {
      dispatch,
    } = this.props;
    // const targetVal = e.target.value;
    // if (e.target.value === "") {
    //   return;
    // }

    dispatch(getPerceptions());
    dispatch(getCohorts());
  };

  public cohortSelectionHandler = (event) => {
    const cohort = event.target.value;
    const tourStatus = localStorage.getItem(
      `${this.props.services.currentUsername}DataCenterTour`
    );
    let guidesRead = true;
    if (tourStatus === null) {
      guidesRead = false;
    }
    this.setState({
      // cohortID: cohort,
      // perceptionsDataLoaded: false,
      // selectedPerception: null,
      guidesRead,
    });

    this.props.dispatch(
      updateMultipleVals({
        perceptionsDataLoaded: false,
        cohortID: cohort,
        selectedPerception: null,
      })
    );
    toast.info(
      "You can now select a perception or select a year group/department"
    );
  };

  public onNodeItemClick = (data) => {
    this.props.history.push(`/schools/viewstudentdata/${data.studentId}`);
  };

  public renderCohortsPicker = () => {
    const { cohorts, cohortsLoaded, currentUserType } =
      this.props.perceptionsReducer;
    if (cohortsLoaded) {
      return (
        <div className="show-picker">
          <span>
            <select
              name="cohort"
              id="cohort"
              className="custom-select"
              onChange={this.cohortSelectionHandler}
            >
              <option value="">-- Great, Now Pick a Cohort</option>
              {cohorts.map((item) => (
                <option value={item.cohort} key={item.cohort}>
                  {item.cohort} : {item.total} Students
                </option>
              ))}
            </select>
          </span>
        </div>
      );
    } else {
      return "";
    }
  };

  public renderPerceptionsList = () => {
    const {
      perceptionsList,
      perceptionsListLoaded,
      selectedPerception,
      cohortsLoaded,
      cohortID,
    } = this.props.perceptionsReducer;
    if (perceptionsListLoaded && cohortID) {
      return (
        <React.Fragment>
          {perceptionsList.map((perception) => (
            <Button
              key={perception.name}
              value={perception.id}
              onClick={this.perceptionClickHandler}
              className={this.assignClass(perception.id, selectedPerception)}
            >
              {perception.name}
            </Button>
          ))}
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff2500" />;
    }
  };

  public renderSwarmPlot = () => {
    const {
      perceptionsData,
      perceptionsDataLoaded,
      studentCount,
      cohortsLoaded,
      isLoading,
    } = this.props.perceptionsReducer;

    const groups = new Set();

    // levelCounts = [extreme, high, moderate, low, no]
    const levelCounts = [0, 0, 0, 0, 0];

    if (perceptionsDataLoaded && cohortsLoaded) {
      const graphData = perceptionsData.map((student, i) => {
        groups.add(student.group);
        return {
          id: i,
          group: student.group,
          studentId: student.id,
          studentName: student.name,
          perceptionLevel: Math.round(student.perceptionLevel * 12.5),
        };
      });

      perceptionsData.forEach((student) => {
        const level = Math.round(student.perceptionLevel * 12.5);

        if (level > 0 && level <= 20) {
          levelCounts[0] += 1;
        } else if (level > 20 && level <= 40) {
          levelCounts[1] += 1;
        } else if (level > 40 && level <= 60) {
          levelCounts[2] += 1;
        } else if (level > 60 && level <= 80) {
          levelCounts[3] += 1;
        } else if (level > 80 && level <= 100) {
          levelCounts[4] += 1;
        }
      });

      return (
        <ComponentWrapper className="animated fadeInUp" height="640px">
          <SwarmPlot
            data={graphData}
            groups={Array.from(groups)}
            entries={studentCount}
            onNodeItemClick={this.onNodeItemClick}
          />

          <div className="summary-stats">
            <p className="summary-stat">
              Extremely Urgent Attention Needed:{" "}
              <span style={{ color: calcColor(10) }}>{levelCounts[0]}</span>{" "}
            </p>
            <p className="summary-stat">
              Urgent Attention Needed:{" "}
              <span style={{ color: calcColor(30) }}>{levelCounts[1]}</span>{" "}
            </p>
            <p className="summary-stat">
              Moderate Attention Needed:{" "}
              <span style={{ color: calcColor(50) }}>{levelCounts[2]}</span>{" "}
            </p>
            <p className="summary-stat">
              Low Attention Needed:{" "}
              <span style={{ color: calcColor(70) }}>{levelCounts[3]}</span>{" "}
            </p>
            <p className="summary-stat">
              No Attention Needed:{" "}
              <span style={{ color: calcColor(90) }}>{levelCounts[4]}</span>{" "}
            </p>
          </div>
        </ComponentWrapper>
      );
    } else {
      return isLoading ? <Loader color="#acff24" /> : "";
    }
  };

  public render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Tour
          steps={tourSteps}
          isOpen={!this.state.guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <Container>
          <Row>
            <Heading>Your Perceptions Performance</Heading>
            <Description>
              Please choose a cohort and perception you'd like to explore
            </Description>
          </Row>
          <Row>{this.renderCohortsPicker()}</Row>
          <Wrapper className="step-1">{this.renderPerceptionsList()}</Wrapper>
          <Row>
            {this.props.perceptionsReducer.firstClickDone
              ? this.renderSwarmPlot()
              : ""}
          </Row>
        </Container>
        <FabButton
          right="8px"
          bottom="36px"
          bgColor="#1a1a1a"
          onClick={this.toggleGuides}
        >
          <p className="fab-text">Need a hand</p>
          <i
            className="fa fa-question"
            style={{ fontSize: "30px", color: "#ff0033" }}
          />
        </FabButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { perceptionsReducer: state.teacherPerceptionsReducer };
};

export default connect(mapStateToProps)(withServices(SchoolPerceptions));



// WEBPACK FOOTER //
// ./src/pages/DataCenter/Teacher/TeacherPerceptions.Component.tsx